export default __webpack_public_path__ + "static/media/car.8a50352e.png";